const decodeBase64 = (text : string) => {
    return atob(text);
}

export default decodeBase64;